export const environment = {
  production: false,
  baseHref: '/',
  redirectUri: 'https://documents.amgreetings.com/',
  postLogoutRedirectUri: 'https://documents.amgreetings.com/',
  webApi: 'https://documents-api.prod.ag2goservices.amgreetings.com',
  tablePaginationSizes: [10, 25, 100],
  pageableAllItems: 99999,
  noLoadingSpinnerHeader: 'loading-spinner-disabled',
  httpRequestChunkSize: 100,
  maxFileUploadSizeMB: 10
};
